/* Cocon du Soir — petits plus de Noël : compte à rebours livraison, calculateur de sapin, neige, dates des avis, badges avis boutique. */
(function () {
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Compte à rebours : date limite de commande pour être livré avant Noël (20 décembre, 23 h 59, heure de Paris) */
  function compteARebours() {
    var cibles = [];
    document.querySelectorAll('.annonce p').forEach(function (p) { if (/20 d[ée]cembre/i.test(p.textContent)) cibles.push(p.querySelector('a, span')); });
    if (!cibles.length) return;
    var maintenant = new Date();
    var an = maintenant.getFullYear();
    var limite = new Date(Date.UTC(an, 11, 20, 22, 59, 0)); /* 20/12 23:59 Paris (UTC+1) */
    var noel = new Date(Date.UTC(an, 11, 25, 0, 0, 0));
    var ms = limite - maintenant, html;
    if (maintenant > noel) return;
    if (ms <= 0) html = 'Commandes après le 20/12 : livraison avant Noël non garantie';
    else {
      var j = Math.floor(ms / 86400000);
      if (j >= 1) html = 'Livré avant Noël : encore <strong>' + j + ' jour' + (j > 1 ? 's' : '') + '</strong> pour commander';
      else html = 'Dernier jour pour être livré avant Noël : <strong>' + Math.floor(ms / 3600000) + ' h ' + Math.floor((ms % 3600000) / 60000) + ' min</strong>';
    }
    cibles.forEach(function (el) { if (el) el.innerHTML = html; });
  }

  /* 2. Calculateur « Quelle taille de sapin pour mon plafond ? » (collections et fiches de sapins) */
  function calculateur() {
    var b = document.body.className;
    var cible = null;
    if (/gabarit-collection/.test(b) && /sapin/.test(location.pathname)) {
      cible = document.querySelector('.collection-outils');
    } else if (/gabarit-product/.test(b)) {
      var t = document.querySelector('.infos__titre');
      if (t && /^sapin|petit sapin/i.test(t.textContent.trim())) cible = document.querySelector('.accordeons');
    }
    if (!cible) return;
    var bloc = document.createElement('div');
    bloc.className = 'calc-sapin';
    bloc.innerHTML =
      '<div class="calc-sapin__texte"><p class="calc-sapin__titre">🎄 Quelle taille de sapin pour mon plafond ?</p>' +
      '<label class="calc-sapin__champ">Hauteur sous plafond <span><input type="range" min="200" max="320" step="5" value="250" aria-label="Hauteur sous plafond en centimètres"><output>2,50 m</output></span></label>' +
      '<p class="calc-sapin__reponse" aria-live="polite"></p></div>' +
      '<svg class="calc-sapin__dessin" viewBox="0 0 120 160" aria-hidden="true"><line class="calc-sapin__plafond" x1="0" x2="120" y1="8" y2="8"/><line x1="0" x2="120" y1="152" y2="152" class="calc-sapin__sol"/><g class="calc-sapin__arbre"><polygon points="60,0 95,100 25,100" /><rect x="54" y="100" width="12" height="14" rx="2"/><circle cx="60" cy="-4" r="5" class="calc-sapin__etoile"/></g></svg>';
    var input = bloc.querySelector('input'), out = bloc.querySelector('output'), rep = bloc.querySelector('.calc-sapin__reponse'), arbre = bloc.querySelector('.calc-sapin__arbre');
    function maj() {
      var p = Number(input.value), max = p - 30, min = Math.max(60, max - 40);
      out.textContent = (p / 100).toFixed(2).replace('.', ',') + ' m';
      var lien = max >= 180 ? ['/collections/grand-sapin-de-noel', 'Voir les grands sapins'] : ['/collections/petit-sapin-de-noel', 'Voir les sapins jusqu\'à 150 cm'];
      rep.innerHTML = 'Votre sapin idéal : <strong>' + Math.round(min) + ' à ' + Math.round(max) + ' cm</strong>. On garde 30 cm pour l\'étoile. <a href="' + lien[0] + '">' + lien[1] + ' →</a>';
      var h = 144 * (max / p), s = h / 123;
      arbre.setAttribute('transform', 'translate(' + (60 - 60 * s) + ',' + (152 - 114 * s) + ') scale(' + s + ')');
    }
    input.addEventListener('input', maj);
    maj();
    cible.parentNode.insertBefore(bloc, cible);
  }

  /* 3. Neige active par défaut ; le bouton ❄ permet au visiteur de la couper (désactivée si l'utilisateur limite les animations) */
  function neige() {
    if (calme) return;
    var on = true; try { on = localStorage.getItem('cocon-neige') !== '0'; } catch (e) {}
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bouton-neige';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.title = 'Neige : activer ou couper';
    btn.innerHTML = '<span aria-hidden="true">❄</span><span class="visuel-masque">Activer ou couper la neige</span>';
    document.body.appendChild(btn);
    var couche = null;
    function lancer() {
      couche = document.createElement('div'); couche.className = 'neige-ecran'; couche.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 40; i++) {
        var f = document.createElement('i');
        f.style.left = (Math.random() * 100) + '%';
        f.style.animationDuration = (7 + Math.random() * 8) + 's';
        f.style.animationDelay = (-Math.random() * 12) + 's';
        f.style.opacity = (0.4 + Math.random() * 0.6).toFixed(2);
        var t = (3 + Math.random() * 5).toFixed(1); f.style.width = t + 'px'; f.style.height = t + 'px';
        couche.appendChild(f);
      }
      document.body.appendChild(couche);
    }
    function arreter() { if (couche) { couche.remove(); couche = null; } }
    if (on) lancer();
    btn.addEventListener('click', function () {
      on = !on; btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      try { localStorage.setItem('cocon-neige', on ? '1' : '0'); } catch (e) {}
      if (on) lancer(); else arreter();
    });
  }

  /* 4. Avis Judge.me : dates au format français (JJ/MM/AAAA) */
  function datesAvis() {
    var re = /^\s*(\d{2})\/(\d{2})\/(\d{4})\s*$/;
    function corriger() {
      document.querySelectorAll('.jdgm-widget span, .jdgm-carousel span, [class*="jdgm"] span, [class*="jm-"] span').forEach(function (el) {
        if (el.children.length) return;
        var t = el.textContent;
        if (el.dataset.dateFr === t) return;
        var m = t.match(re);
        if (!m) return;
        var fr = m[2] + '/' + m[1] + '/' + m[3];
        el.textContent = fr; el.dataset.dateFr = fr;
      });
    }
    corriger();
    if (!window.MutationObserver) return;
    var minuterie;
    new MutationObserver(function () { clearTimeout(minuterie); minuterie = setTimeout(corriger, 120); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* 5. Note de la boutique sous le prix (fiches) et sur la photo d'accueil ; un clic descend jusqu'aux avis */
  function badgesAvis() {
    var note = document.querySelector('.avis-boutique__note');
    var cible = document.getElementById('avis-boutique-titre');
    if (!note || !cible) return;
    var st = document.createElement('style');
    st.textContent = '.badge-avis{display:inline-flex;align-items:center;flex-wrap:wrap;gap:8px;font-size:14px;line-height:1.2;color:inherit;text-decoration:none;cursor:pointer}' +
      '.badge-avis__voir{text-decoration:underline;text-underline-offset:2px;opacity:.85}' +
      '.badge-avis--fiche{display:flex;margin:10px 0 0}' +
      '.heros__photo{position:relative}' +
      '.badge-avis--photo{position:absolute;left:12px;bottom:12px;z-index:2;padding:8px 12px;border-radius:999px;background:rgba(255,255,255,.95);color:#1b1b1b;box-shadow:0 4px 14px rgba(0,0,0,.2)}' +
      '.badge-avis--photo .etoiles-or i{width:16px;height:16px}' +
      '#avis-boutique-titre{scroll-margin-top:96px}';
    document.head.appendChild(st);
    function creer(cls, voir) {
      var a = document.createElement('a');
      a.href = '#avis-boutique-titre';
      a.className = 'badge-avis ' + cls;
      a.innerHTML = note.innerHTML + (voir ? '<span class="badge-avis__voir">Voir les avis</span>' : '');
      a.addEventListener('click', function (e) { e.preventDefault(); cible.scrollIntoView({ behavior: calme ? 'auto' : 'smooth', block: 'start' }); });
      return a;
    }
    var prix = document.querySelector('[data-infos-prix]');
    if (prix) prix.insertAdjacentElement('afterend', creer('badge-avis--fiche', true));
    var photo = document.querySelector('.heros__photo');
    if (photo) photo.appendChild(creer('badge-avis--photo', false));
  }

  function demarrer() { compteARebours(); calculateur(); neige(); datesAvis(); badgesAvis(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
